interface IProps {
  progressBarValue: number
}

const AttachmentProgressBar: React.FC<IProps> = ({progressBarValue}) => {
  return (
    <div style={{ marginBottom: '-25px'}}>
      {progressBarValue > 0 && 
        <div>
          <label style={{ position: 'relative', top: '-13px', display: 'block', margin: '0' }}>
            <progress className="custom-progress" value={progressBarValue} max="100"  style={{ width: '100%', height: '4px' }}/>
          </label>
          <span style={{ position: 'relative',  right: '0', top: '-28px', fontSize: '10px', color: '#005eb8' }}> 
              {progressBarValue}% 
          </span>
        </div>
      }
    </div>
    
  )
}

export { AttachmentProgressBar }
